import styled from '@emotion/styled';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';
import { memo } from 'react';
import QuoteContent from './QuoteContent';

const Wrapper = styled.div<{ from: Conversation.Message['msgFromType'] }>`
  padding: 8px;
  border-radius: 4px;
  background-color: #fff;
`;

export interface QuoteMessageProps extends Omit<ParagraphProps, 'children' | 'ellipsis'> {
  message?: Conversation.Message;
  divider?: React.ReactNode;
  storeName?: Conversation.Conversation['storeName'];
  wrap?: boolean;
  children?: React.ReactNode;
  onQuoteClick?: (msgId: string) => void;
}

const QuoteMessage = (props: QuoteMessageProps) => {
  const { message, wrap, storeName, children, onQuoteClick } = props;
  if (!message) return null;
  const { region, channel, conversationId } = message;
  const content = message?.quotedMsg ? (
    <QuoteContent
      quotedMsg={message.quotedMsg}
      region={region}
      channel={channel}
      conversationId={conversationId}
      storeName={storeName}
      onClick={onQuoteClick}
    />
  ) : null;

  if (wrap) {
    return content ? (
      <Wrapper from={message.msgFromType}>
        {content}
        {children}
      </Wrapper>
    ) : (
      <>{children}</>
    );
  }

  return content;
};

export default memo(QuoteMessage);
